import React, { SFC } from "react";
import { Button, Paragraph } from "scuid-x";
import * as ManualCaptureButton from "../../assets/images/manual-capture-button.svg";
import { DocType } from "../../constants/DocType";
import { PrettyIdNames } from "../../constants/PrettyIdNames";
import "./ManualInstructions.css";

export interface ManualInstructionsProps {
  docType: DocType;
  onDone: () => void;
}

export const  ManualInstructions: SFC<ManualInstructionsProps> = (props: ManualInstructionsProps) => {
  const idName = PrettyIdNames.getIdNames(props.docType).shortName;

  return (
    <div className={"ManualInstructions-container"}>
      <Paragraph >
        Sorry, we are having a problem automatically capturing your {idName}. Please place your {idName} on
        a plain dark background and get all 4 corners in the frame. When you are ready,
        press the capture button <img src={ManualCaptureButton}/> to take a picture.
      </Paragraph>
      <Button onClick={props.onDone}>
        Got it
      </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/doc-capture/ManualInstructions.tsx